import { c as _c } from "react/compiler-runtime";
import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useMediaState } from '../hooks/use-media-state';
export type PopupProps = {
  isOpen: boolean;
  onClose: VoidFunction;
  renderContent: (props: {
    onClose: VoidFunction;
  }) => ReactNode;
};
const variants = {
  backdrop: {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    }
  },
  panel: {
    initial: (isMobile: boolean) => ({
      [isMobile ? 'y' : 'x']: '100%'
    }),
    animate: (isMobile: boolean) => ({
      [isMobile ? 'y' : 'x']: 0
    }),
    exit: (isMobile: boolean) => ({
      [isMobile ? 'y' : 'x']: '100%'
    })
  }
};
export const Popup = t0 => {
  const $ = _c(5);
  const {
    renderContent,
    isOpen,
    onClose
  } = t0;
  const isMobile = useMediaState("mobile");
  let t1;
  if ($[0] !== isMobile || $[1] !== isOpen || $[2] !== onClose || $[3] !== renderContent) {
    t1 = isOpen && createPortal(<AnimatePresence><m.div key="backdrop" initial="initial" animate="animate" exit="exit" transition={{
        duration: 0.2
      }} variants={variants.backdrop} onClick={onClose} className="fixed inset-0 z-popup size-full flex-col bg-backdrop"><m.div key="panel" initial="initial" animate="animate" exit="exit" custom={isMobile} transition={{
          duration: 0.2
        }} variants={variants.panel} className="sm:fluid-container size-full sm:relative"><div className="absolute inset-x-2 bottom-2 flex max-h-full flex-1 translate-x-0 overflow-hidden rounded-3xl bg-white p-6 sm:top-24 sm:right-6 sm:bottom-auto sm:left-auto sm:flex sm:max-w-112 sm:rounded-xl md:right-12 lg:right-16" onClick={_temp}>{renderContent({
              onClose
            })}</div></m.div></m.div></AnimatePresence>, document.body);
    $[0] = isMobile;
    $[1] = isOpen;
    $[2] = onClose;
    $[3] = renderContent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
function _temp(event) {
  return event.stopPropagation();
}